import { AppGlueCoreInit } from "../../../../AppGlueCoreInit";
import { StatementRuleConfiguration } from "../../../../rule-engine-core/Rule/Statement/StatementRuleConfiguration";
import { RuleTableConfiguration } from "../../../../rule-engine-core/Rule/Table/Rule/RuleTableConfiguration";
import { ValueTableConfiguration } from "../../../../rule-engine-core/Rule/Table/Value/ValueTableConfiguration";
import { TextMergeConfiguration } from "../../../../rule-engine-core/TextMerge/TextMergeConfiguration";
import type { AppGlueStorageBackedConfig, RuleStorageCodecPort } from "../ruleIntegrationTypes";

export const createAppGlueStorageCodec = <Config extends AppGlueStorageBackedConfig>(
    createConfig: () => Config,
): RuleStorageCodecPort<Config> => ({
    serialize: (config) => config.getStorageData(),
    hydrate: (storageData) => {
        AppGlueCoreInit.init();
        const config = createConfig();
        config.setStorageData(storageData);
        return config;
    },
});

export const statementRuleStorageCodec = (): RuleStorageCodecPort<StatementRuleConfiguration> =>
    createAppGlueStorageCodec(() => new StatementRuleConfiguration());

export const ruleTableStorageCodec = (): RuleStorageCodecPort<RuleTableConfiguration> =>
    createAppGlueStorageCodec(() => new RuleTableConfiguration());

export const valueTableStorageCodec = (): RuleStorageCodecPort<ValueTableConfiguration> =>
    createAppGlueStorageCodec(() => new ValueTableConfiguration());

export const textMergeStorageCodec = (): RuleStorageCodecPort<TextMergeConfiguration> =>
    createAppGlueStorageCodec(() => new TextMergeConfiguration());
